'use strict';
/* eslint no-console: 0 */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ = require('_');

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _BaseEventLogger2 = require('event-tracking-tools/loggers/BaseEventLogger');

var _BaseEventLogger3 = _interopRequireDefault(_BaseEventLogger2);

var _ProductEventRecord = require('event-tracking-tools/records/ProductEventRecord');

var _ProductEventRecord2 = _interopRequireDefault(_ProductEventRecord);

var _AmplitudeEventRecord = require('event-tracking-tools/records/AmplitudeEventRecord');

var _AmplitudeEventRecord2 = _interopRequireDefault(_AmplitudeEventRecord);

var _hubspotHublyticsTrackerJS = require('hubspot.HublyticsTrackerJS.tracker');

var _hubspotHublyticsTrackerJS2 = _interopRequireDefault(_hubspotHublyticsTrackerJS);

var _hublyticsEventClasses = require('event-tracking-tools/hublytics/hublyticsEventClasses');

var _getIsDebugMode = require('event-tracking-tools/utils/getIsDebugMode');

var _getIsDebugMode2 = _interopRequireDefault(_getIsDebugMode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IS_PROD = _enviro2.default.getShort() === 'prod';
var ACCEPTED_PROPS = ['where_app_override', 'what_version', 'what_variation', 'what_event_subtype', 'what_value', 'what_value_str', 'where_referer', 'where_screen', 'where_subscreen', 'where_subscreen2', 'who_team_identifier'];

function _getCanTrack(isInit, eventClass, eventName) {
  if (!isInit) {
    if (!IS_PROD) {
      console.warn('ProductEventLogger Warning: Tried to track ' + eventClass + ' \'' + eventName + '\' before initialized.');
    }
    return false;
  }
  return true;
}

function _getIsAmplitudeRecord(record) {
  return record instanceof _AmplitudeEventRecord2.default;
}

var ProductEventLogger = function (_BaseEventLogger) {
  _inherits(ProductEventLogger, _BaseEventLogger);

  function ProductEventLogger(_ref) {
    var app = _ref.app,
        accountId = _ref.accountId,
        userIdentifier = _ref.userIdentifier,
        teamIdentifier = _ref.teamIdentifier,
        email = _ref.email,
        who_identifier_v2 = _ref.who_identifier_v2,
        isExternal = _ref.isExternal,
        batchRequests = _ref.batchRequests,
        _ref$initialize = _ref.initialize,
        initialize = _ref$initialize === undefined ? true : _ref$initialize,
        _ref$dropUnrecognized = _ref.dropUnrecognized,
        dropUnrecognized = _ref$dropUnrecognized === undefined ? true : _ref$dropUnrecognized,
        useStrict = _ref.useStrict;

    _classCallCheck(this, ProductEventLogger);

    var _this = _possibleConstructorReturn(this, (ProductEventLogger.__proto__ || Object.getPrototypeOf(ProductEventLogger)).call(this, { useStrict: useStrict }));

    _this.acceptedRecord = [_ProductEventRecord2.default, _AmplitudeEventRecord2.default];
    _this.initialized = false;
    _this.doInit = initialize;
    _this.dropUnrecognized = dropUnrecognized;
    _this.config = {};
    _this.setConfig({
      isExternal: isExternal,
      app: app,
      accountId: accountId,
      userIdentifier: userIdentifier,
      teamIdentifier: teamIdentifier,
      email: email,
      who_identifier_v2: who_identifier_v2,
      batchRequests: batchRequests
    });
    if (_this.doInit) {
      _this.init();
    }
    return _this;
  }

  _createClass(ProductEventLogger, [{
    key: 'setConfig',
    value: function setConfig(_ref2) {
      var isExternal = _ref2.isExternal,
          app = _ref2.app,
          accountId = _ref2.accountId,
          userIdentifier = _ref2.userIdentifier,
          teamIdentifier = _ref2.teamIdentifier,
          email = _ref2.email,
          who_identifier_v2 = _ref2.who_identifier_v2,
          batchRequests = _ref2.batchRequests;

      this.config = {
        env: _enviro2.default.getShort(),
        isExternal: isExternal || false,
        app: app,
        accountId: accountId,
        userIdentifier: userIdentifier,
        teamIdentifier: teamIdentifier,
        email: email,
        who_identifier_v2: who_identifier_v2,
        batchRequests: batchRequests
      };
    }
  }, {
    key: 'init',
    value: function init(newConfig) {
      if (newConfig) {
        this.setConfig(newConfig);
      }
      _hubspotHublyticsTrackerJS2.default.init(this.config);
      this.initialized = true;
    }
  }, {
    key: 'getIsHublyticsInitialized',
    value: function getIsHublyticsInitialized() {
      return _hubspotHublyticsTrackerJS2.default.who_identifier_v2 || _hubspotHublyticsTrackerJS2.default.email;
    }

    // Creates a hublytics-style payload

  }, {
    key: 'transform',
    value: function transform(Record, props) {
      var isAmplitudeRecord = _getIsAmplitudeRecord(Record);

      var eventClass = isAmplitudeRecord ? _hublyticsEventClasses.INTERACTION : Record.type;
      var eventName = isAmplitudeRecord ? Record.namespace : Record.name;

      // HublyticsTrackerJS.MarketingAppTracker automatically takes care of
      // most of the vital information in the who_* properties.
      var payload = {
        // Added here so it gets sent with all events
        what_event: eventName,

        // Version: This is useful to bump when updating a feature or running
        // an experiment and you need to segment.
        what_version: 'v1',

        // Stripped off in send()
        what_event_class: eventClass
      };

      var emailValue = this.config.email || _hubspotHublyticsTrackerJS2.default.email;
      if (emailValue) {
        payload.who_email = emailValue;
      }

      var expectedPropKeys = Object.keys(Record.propTypes);

      // Apply default values if propTypes arent a validator function.
      // THIS WILL CAUSE DEFAULTS TO OVERWRITE USER-PASSED PROPS.
      expectedPropKeys.forEach(function (key) {
        var maybeDefaultValue = Record.propTypes[key];
        if ((0, _.isString)(maybeDefaultValue) || (0, _.isNumber)(maybeDefaultValue) || (0, _.isBoolean)(maybeDefaultValue)) {
          props[key] = maybeDefaultValue;
        }
      });

      // Override the values in payload with prop values
      ACCEPTED_PROPS.forEach(function (name) {
        if (props[name] !== undefined && expectedPropKeys.indexOf(name) !== -1) {
          payload[name] = props[name];
          delete props[name];
        }
      });

      if (this.dropUnrecognized) {
        // Delete any props that arent expected
        Object.keys(props).forEach(function (name) {
          if (expectedPropKeys.indexOf(name) === -1) {
            console.warn('ProductEventLogger Warning: [' + eventName + '] Event prop \'' + name + '\' was not expected in Record.propTypes. This will be ignored!');
            delete props[name];
          }
        });
      }

      if (isAmplitudeRecord) {
        props.action = Record.action;

        if (Record.isViewEvent) {
          payload.what_event_class = _hublyticsEventClasses.VIEW;
        }

        if (props.screen) {
          payload.where_screen = props.screen;
        }

        if (props.location) {
          payload.where_subscreen = props.location;
        }
      }

      if (!(0, _.isEmpty)(props)) {
        payload.what_extra_json = props;
      }

      if ((0, _getIsDebugMode2.default)()) {
        payload.what_extra_json = JSON.stringify(payload.what_extra_json);
      }

      return payload;
    }

    // fired events to hublyticstracker

  }, {
    key: 'send',
    value: function send(payload) {
      var eventClass = payload.what_event_class;
      delete payload.what_event_class;

      // Allow tracking if hublytics is being managed somewhere else (this
      // usually concerns upstream deps or embedded apps like Twilio).
      if (!this.doInit && !this.initialized && this.getIsHublyticsInitialized()) {
        this.initialized = true;
      }

      if (!_getCanTrack(this.initialized, eventClass, payload.what_event)) {
        return false;
      }

      // To keep things from getting confusing, where_screen and where_subscreen
      // will only be used for VIEW events
      var where_screen = payload.where_screen,
          where_subscreen = payload.where_subscreen;

      delete payload.where_screen;
      delete payload.where_subscreen;

      // Note: environment is saved in HublyticsTrackerJS
      if (eventClass === _hublyticsEventClasses.VIEW) {
        _hubspotHublyticsTrackerJS2.default.trackScreen(where_screen, where_subscreen, payload);
      } else {
        _hubspotHublyticsTrackerJS2.default.trackEventWithClass(eventClass, payload.what_event, payload);
      }

      var queueLength = _hubspotHublyticsTrackerJS2.default.eventsQueue.length;
      var logLength = _hubspotHublyticsTrackerJS2.default.eventsLog.length;

      // try to return the hublytics-formatted event
      if (logLength) {
        return _hubspotHublyticsTrackerJS2.default.eventsLog[logLength - 1];
      } else if (queueLength) {
        return _hubspotHublyticsTrackerJS2.default.eventsQueue[queueLength - 1];
      }

      return null;
    }
  }]);

  return ProductEventLogger;
}(_BaseEventLogger3.default);

exports.default = ProductEventLogger;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/event-tracking-tools/static-1.15/js/loggers/ProductEventLogger.js
// module id = 539
// module chunks = 0